import { axiosClient } from '../../../shared/api';

export const listLoads = async (query = '') => {
  const response = await axiosClient.get(`/loads${query}`);
  return response.data;
};

export const getLoad = async (loadId) => {
  const response = await axiosClient.get(`/loads/${loadId}`);
  return response.data;
};

export const createLoad = async (loadData) => {
  const response = await axiosClient.post('/loads', loadData);
  return response.data;
};

export const updateLoad = async (loadId, updatedData) => {
  const response = await axiosClient.put(`/loads/${loadId}`, updatedData);
  return response.data;
};

export const getLoadStats = async () => {
  const response = await axiosClient.get('/loads/stats');
  return response.data;
};
